import { render, staticRenderFns } from "./editClientSkuDialog.vue?vue&type=template&id=642032f2&"
import script from "./editClientSkuDialog.vue?vue&type=script&lang=js&"
export * from "./editClientSkuDialog.vue?vue&type=script&lang=js&"
import style0 from "./editClientSkuDialog.vue?vue&type=style&index=0&id=642032f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports